import { ButtonLink } from "components/ui"

export const CTASection = () => {
  return (
    <div className="bg-white dark:bg-gray-900">
      <div className="mx-auto max-w-7xl px-6 py-24 sm:py-32 lg:flex lg:items-center lg:justify-between lg:px-8">
        <h2 className="max-w-2xl text-4xl font-semibold tracking-tight text-gray-900 dark:text-white sm:text-5xl">
          Ready to create memories? <br />
          Create your free account today.
        </h2>
        <div className="mt-10 flex items-center gap-x-6 lg:mt-0 lg:shrink-0">
          <ButtonLink to="/signup" size="lg">
            Create your account
          </ButtonLink>
        </div>
      </div>
    </div>
  )
}
